
import { defineComponent, PropType } from 'vue'
import { iNodeMetadataField } from '../../../HierarchyManagement'
import moment from 'moment'
import Calendar from 'primevue/calendar'
import Dialog from 'primevue/dialog'
import hierarchyManagementHierarchiesTreeDescriptor from './HierarchyManagementHierarchiesTreeDescriptor.json'

const deepcopy = require('deepcopy')

export default defineComponent({
    name: 'hierarchy-management-node-detail-dialog',
    components: { Calendar, Dialog },
    props: { visible: { type: Boolean }, selectedNode: { type: Object }, metadata: { type: Array as PropType<iNodeMetadataField[]> }, mode: { type: String } },
    emits: ['save', 'close'],
    data() {
        return {
            hierarchyManagementHierarchiesTreeDescriptor,
            node: null as any
        }
    },
    watch: {
        selectedNode() {
            this.loadNode()
        }
    },
    async created() {
        this.loadNode()
    },
    methods: {
        loadNode() {
            this.node = deepcopy(this.selectedNode)
            this.metadata?.forEach((el: iNodeMetadataField) => {
                if (el.TYPE === 'Date' && this.node[el.ID]) {
                    this.node[el.ID] = this.mode === 'clone' ? new Date() : moment(this.node[el.ID], 'YYYY-MM-DD').toDate()
                }
            })
        },
        close() {
            this.node = null
            this.$emit('close')
        },
        save() {
            this.formatNode()
            this.$emit('save', { node: this.node, mode: this.mode })
            this.node = null
        },
        formatNode() {
            this.node.name = this.node[this.node?.aliasName]
            this.metadata?.forEach((el: iNodeMetadataField) => {
                if (el.TYPE === 'Date' && this.node[el.ID]) {
                    this.node[el.ID] = moment(this.node[el.ID]).format('YYYY-MM-DD')
                }
            })
        }
    }
})
